export const infoAlert = {
  title: 'Buen trabajo!!!',
  text: 'Ya puedes seguir utilizando Colfactura Nómina ',
};
